export default "__VITE_ASSET__92f0d009__"